import { useParams } from "react-router-dom"
import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useImportUserDNCMutation } from "@/redux/services/userDncApi"
import { setToast } from "@/redux/toastSlice"

export const useUserImportDNC = () => {
  const dispatch = useAppDispatch()
  const { id: orgId = "" } = useParams()
  const [importUserDNC, response] = useImportUserDNCMutation()

  const handleImportUserDNC = async (file: File | Blob) => {
    try {
      const formData = new FormData()
      formData.append("csv", file)
      const response = await importUserDNC({ body: formData, orgId }).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success add contacts",
          }),
        )
      }
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(message)
    }
  }

  return { importUserDNC: handleImportUserDNC, response }
}
